import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserAuth } from "./AuthContext";
import logo from "../images/logo.png";
import Signin from "./Signin";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import ListingPopUp from "./ListingPopUp.js";
import { Padding } from "@mui/icons-material";
import {Text} from "@chakra-ui/react"
// import "../index.css";
// don't know if I need this line?

const Navbar = () => {
  const { user, logOut } = UserAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // if (user == undefined) {
    //   console.log("user is undefined");
    //   return;
    // }
    if (user != null && !isEmpty(user)) {
      console.log("navigating to dashboard in navbar");
      navigate("/dashboard");
    }
  }, [user]);

  return (
    <div className="nav_bar">
      {user ? (
        <Link to="/dashboard">
          <img
            src={logo}
            className="logo"
            width="70px"
            alt="logo of box with items"
          />
          {/* <Text color="black" fontSize={20} align="center">FoodSurf</Text> */}
        </Link>
      ) : (
        <Link to="/"></Link>
      )}
      

      {user?.displayName ? (
        <Link to="/dashboard">
          <button className="button_white_small" onClick={handleSignOut}>
            Logout
          </button>
        </Link>
      ) : (
        <Link to="/">
          <Signin />
        </Link>
      )}
    </div>
  );
};
export default Navbar;
